import React from "react";

export default function MSAccess_Weekday() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Weekday</h1>
      <p>This is the MSAccess_Weekday component generated from the SQL JSON.</p>
    </div>
  );
}
